// extracted by mini-css-extract-plugin
module.exports = {"root":"rank-publish-flag_root__1mARe","text":"rank-publish-flag_text__8bFAk"};